import React, { useRef, useState } from 'react';
import { showToast } from '../../../services/common-service';
import BlipPortalToastTypes from '../../../constants/blip-portal-toast-types';


import "./styles.scss"
import VersionItem from './VersionItem';

export default function VersionsComponent({
    name,
    pipes,
    newPipes,
    setNewPipes,
    versions = []
}) {
    const inputUploadRed = useRef()

    const [isVersionsOpened, setIsVersionsOpened] = useState(false)

    const download = () => {
        // create file in browser
        const fileName = `pipes_${name.split(" ").join("_")}`;
        const json = JSON.stringify(newPipes, null, 2);
        const blob = new Blob([json], { type: "application/json" });
        const href = URL.createObjectURL(blob);

        // create "a" HTLM element with href to file
        const link = document.createElement("a");
        link.href = href;
        link.download = fileName + ".json";
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }

    const upload = (event) => {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            try {
                let json = JSON.parse(content)

                event.target.value = null;

                if (!Array.isArray(json))
                    throw { message: "Formato inválido" }

                console.log(json)

                setNewPipes(json)

                showToast({
                    type: BlipPortalToastTypes.SUCCESS,
                    message: "Pipes carregados com sucesso"
                });
            } catch (error) {
                showToast({
                    type: BlipPortalToastTypes.DANGER,
                    message: error?.message || "Ocorreu um erro"
                });
            }
        };
        reader.readAsText(file);
    }

    const restoreActual = () => {
        setNewPipes(pipes)

        showToast({
            type: BlipPortalToastTypes.SUCCESS,
            message: "Pipes restaurados com sucesso"
        });
    }

    return (
        <div className="ph3 pv3">
            <div className="flex flex-column">
                <div className="btn2 pv3 ph4 br4 mb3 flex items-center custom-action-item" ng-click="$ctrl.showFileDialog($event)" onClick={() => inputUploadRed?.current?.click()}>
                    <bds-icon name="upload" size="small" class="flex-shrink-0 mr4 bds-icon bds-icon__size--small hydrated" role="img" aria-label="upload" theme="outline"></bds-icon>
                    <bds-typo variant="fs-14" tag="span" class="w-100 hydrated" translate="">Carregar pipes</bds-typo>

                    <input
                        type="file"
                        accept=".json"
                        style={{ display: 'none' }}
                        onChange={upload}
                        ref={inputUploadRed}
                    />
                </div>

                <div className="btn2 pv3 ph4 br4 mb3 flex items-center custom-action-item" onClick={download}>
                    <bds-icon name="download" size="small" class="flex-shrink-0 mr4 bds-icon bds-icon__size--small hydrated" role="img" aria-label="upload" theme="outline"></bds-icon>
                    <bds-typo variant="fs-14" tag="span" class="w-100 hydrated" translate="">Baixar pipes</bds-typo>
                </div>

                <div className="btn2 pv3 ph4 br4 mb3 flex items-center custom-action-item" onClick={restoreActual}>
                    <div className="mr4" style={{ padding: 0 }}>
                        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{ width: 20, padding: 0, margin: 0 }}>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.31459 3.1809C8.75635 2.41034 10.365 2.00498 11.9998 2.00034C13.5231 1.98786 15.0292 2.32361 16.4031 2.98194C17.7769 3.64027 18.9821 4.60378 19.9268 5.79893C20.8715 6.99408 21.5306 8.38926 21.8539 9.87798C22.1772 11.3667 22.156 12.9096 21.7921 14.3889C21.4282 15.8682 20.7311 17.2448 19.754 18.4137C18.7769 19.5825 17.5457 20.5126 16.1544 21.1331C14.7631 21.7535 13.2483 22.0479 11.7259 21.9937C10.2034 21.9395 8.71349 21.5381 7.36978 20.8203C7.27761 20.7779 7.19501 20.7172 7.12697 20.6419C7.05894 20.5667 7.00689 20.4784 6.97397 20.3824C6.94105 20.2864 6.92795 20.1847 6.93546 20.0835C6.94297 19.9824 6.97093 19.8837 7.01766 19.7937C7.06439 19.7036 7.1289 19.624 7.20731 19.5595C7.28571 19.4951 7.37637 19.4473 7.47379 19.4189C7.57122 19.3906 7.67338 19.3823 7.77411 19.3946C7.87483 19.4068 7.97202 19.4394 8.05978 19.4903C9.27391 20.1348 10.6253 20.4778 11.9998 20.4903C13.4574 20.4852 14.8892 20.1044 16.1568 19.3846C17.4244 18.6649 18.485 17.6306 19.2364 16.3815C19.9878 15.1324 20.4045 13.7107 20.4463 12.2536C20.4881 10.7966 20.1536 9.35331 19.4751 8.06318C18.7966 6.77305 17.797 5.67961 16.5728 4.88838C15.3485 4.09715 13.941 3.63485 12.486 3.54612C11.0311 3.45738 9.57778 3.74519 8.26645 4.38178C6.95513 5.01836 5.83005 5.98222 4.99978 7.18034L5.91978 6.79034C6.01171 6.75488 6.10972 6.73787 6.20821 6.74029C6.30671 6.74272 6.40377 6.76451 6.49384 6.80444C6.58391 6.84437 6.66524 6.90165 6.73317 6.97301C6.80111 7.04437 6.85433 7.12841 6.88978 7.22034C6.92524 7.31226 6.94224 7.41027 6.93982 7.50877C6.9374 7.60726 6.91561 7.70432 6.87568 7.79439C6.83575 7.88446 6.77847 7.96579 6.70711 8.03373C6.63575 8.10166 6.55171 8.15488 6.45978 8.19033L3.99978 9.19033C3.90355 9.22469 3.80196 9.24162 3.69978 9.24034C3.54795 9.24181 3.39935 9.19654 3.27412 9.11067C3.1489 9.0248 3.05312 8.90249 2.99978 8.76034L2.07978 6.30034C2.03377 6.20738 2.00754 6.10589 2.00275 6.00228C1.99796 5.89867 2.01472 5.79519 2.05195 5.69838C2.08919 5.60158 2.1461 5.51355 2.21909 5.43985C2.29208 5.36616 2.37956 5.30841 2.47601 5.27025C2.57245 5.23209 2.67577 5.21434 2.77942 5.21814C2.88307 5.22194 2.9848 5.2472 3.0782 5.29231C3.17159 5.33743 3.25461 5.40143 3.32201 5.48027C3.38941 5.5591 3.43973 5.65106 3.46978 5.75034L3.72978 6.42034C4.64197 5.06374 5.87283 3.95147 7.31459 3.1809ZM10.7636 7.39373C10.9324 7.22495 11.1613 7.13013 11.4 7.13013C11.6336 7.13 11.8581 7.22069 12.026 7.38304C12.194 7.54539 12.2922 7.76667 12.3 8.00013V12.3301L14.62 14.6401C14.7885 14.8105 14.8831 15.0405 14.8831 15.2801C14.8831 15.5198 14.7885 15.7498 14.62 15.9201C14.4484 16.0863 14.2189 16.1792 13.98 16.1792C13.7411 16.1792 13.5116 16.0863 13.34 15.9201L10.76 13.3401C10.5952 13.1675 10.5023 12.9387 10.5 12.7001V8.03013C10.5 7.79143 10.5948 7.56251 10.7636 7.39373ZM3.52001 12.0002C3.51987 12.5437 3.57009 13.086 3.67001 13.6202C3.69013 13.7196 3.6899 13.822 3.66933 13.9213C3.64876 14.0206 3.60828 14.1146 3.55033 14.1978C3.49238 14.281 3.41816 14.3516 3.33217 14.4053C3.24618 14.459 3.15019 14.4947 3.05001 14.5102H2.91001C2.73603 14.5106 2.5675 14.4496 2.434 14.3381C2.3005 14.2265 2.21057 14.0715 2.18001 13.9002C2.05957 13.2741 1.99929 12.6379 2.00001 12.0002C2.00001 11.7987 2.08008 11.6054 2.22261 11.4628C2.36513 11.3203 2.55844 11.2402 2.76001 11.2402C2.96157 11.2402 3.15488 11.3203 3.29741 11.4628C3.43994 11.6054 3.52001 11.7987 3.52001 12.0002ZM4.45015 15.8803C4.40574 15.7934 4.34459 15.7162 4.2702 15.653C4.19582 15.5898 4.10967 15.542 4.01673 15.5123C3.92378 15.4825 3.82587 15.4714 3.72864 15.4797C3.6314 15.488 3.53675 15.5154 3.45015 15.5603C3.27655 15.652 3.1458 15.808 3.08598 15.995C3.02615 16.182 3.04201 16.3849 3.13015 16.5603C3.5277 17.3378 4.02894 18.0577 4.62015 18.7003C4.68867 18.7788 4.7732 18.8418 4.86807 18.8849C4.96294 18.928 5.06594 18.9503 5.17015 18.9503C5.35761 18.9512 5.53894 18.8836 5.68015 18.7603C5.8182 18.6184 5.89544 18.4283 5.89544 18.2303C5.89544 18.0324 5.8182 17.8422 5.68015 17.7003C5.1936 17.1491 4.78018 16.5374 4.45015 15.8803Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    <bds-typo variant="fs-14" tag="span" class="w-100 hydrated" translate="">Restaurar versão publicada</bds-typo>
                </div>

                <div className="mt3">
                    <div className="item-header flex flex-row justify-between w-100 pointer" onClick={() => setIsVersionsOpened(opened => !opened)}>
                        <div className="flex justify-center items-start mr3 mt2" style={{ width: 30 }}>
                            <img src={`/arrow${isVersionsOpened ? "Bottom" : "Right"}Icon.svg`} />
                        </div>
                        <div className="w-100 flex flex-row">
                            <bds-typo class="bp-fs-5 ttu b hydrated" tag="span" variant="fs-16" translate="">Últimas Versões Publicadas</bds-typo>
                        </div>
                    </div>

                    {isVersionsOpened &&
                        <>
                            {versions.length == 0 ?
                                <div className="mt3">
                                    <bds-typo class="bp-fs-5 b hydrated" tag="span" variant="fs-14" translate="">Nenhuma outra versão publicada</bds-typo>
                                </div> :
                                <>
                                    <div className="mt2">
                                        <bds-typo class="bp-fs-5 b hydrated" tag="span" variant="fs-14" translate="">Veja o histórico das últimas versões publicadas.</bds-typo>
                                    </div>

                                    {versions.map((version, index) =>
                                        <VersionItem
                                            key={index}
                                            {...version}
                                            setNewPipes={setNewPipes}
                                        />
                                    )}
                                </>
                            }
                        </>
                    }
                </div>
            </div>
        </div >
    )
}